import { render, staticRenderFns } from "./WDesktop.vue?vue&type=template&id=924b53b6&scoped=true&"
import script from "./WDesktop.vue?vue&type=script&lang=js&"
export * from "./WDesktop.vue?vue&type=script&lang=js&"
import style0 from "./WDesktop.vue?vue&type=style&index=0&id=924b53b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924b53b6",
  null
  
)

/* custom blocks */
import block0 from "./WDesktop.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VLayout})
